import { Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import { Column } from '@ant-design/plots';
import { each, groupBy } from '@antv/util';
import { priceToString } from '../../util/utils';

interface RevenueReportComponentProps {
  data: any[];
}

function RevenueReportComponent({ data }: RevenueReportComponentProps) {
  const annotations: any[] = [];
  each(groupBy(data, 'month'), (values, k) => {
    const value = values.reduce((a: any, b: any) => a + b.value, 0);
    annotations.push({
      type: 'text',
      position: [k, value],
      content: `${priceToString(value)}원`,
      style: {
        textAlign: 'center',
        fontSize: 14,
        fill: 'rgba(0,0,0,0.85)',
      },
      offsetY: -10,
    });
  });

  const config: any = {
    data,
    isStack: true,
    xField: 'month',
    yField: 'value',
    seriesField: 'type',
    label: {
      // 可手动配置 label 数据标签位置
      position: 'middle',
      // 'top', 'bottom', 'middle'
      content: function content(originData: any) {
        return `${priceToString(originData.value)}원`;
      },
      // 可配置附加的布局方法
      layout: [
        // 柱形图数据标签位置自动调整
        {
          type: 'interval-adjust-position',
        }, // 数据标签防遮挡
        {
          type: 'interval-hide-overlap',
        }, // 数据标签文颜色自动调整
        {
          type: 'adjust-color',
        },
      ],
    },
    tooltip: {
      formatter: (datum: any) => {
        return { name: datum.type, value: `${priceToString(datum.value)}원` };
      },
    },
    // 使用 annotation （图形标注）来展示：总数的 label
    annotations,
  };

  return (
    <>
      <Row>
        <Col>
          <Title level={4}>월별 매출현황</Title>
          <Text>
            매출 발생일은 계약일 기준이며, 종료된 프로젝트만 집계됩니다.
          </Text>
        </Col>
      </Row>
      {data.length === 0 ? (
        <Row justify="center" style={{ marginTop: '30px' }}>
          <Col span={4}>
            <Text>데이터가 없습니다.</Text>
          </Col>
        </Row>
      ) : (
        <Row justify="space-between" style={{ marginTop: '30px' }}>
          <Col span={20}>
            <Column {...config} />
          </Col>
        </Row>
      )}
    </>
  );
}

export default RevenueReportComponent;
